module.exports = __webpack_public_path__ + "img/person_icon.dc0b94dc.png";